import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'icon'];
  static values = {
    storageKey: { type: String, default: 'panel-toggle:collapsed' }
  };

  connect() {
    this.element.classList.toggle('is-collapsed', this.collapsed);
    this.syncControls();
  }

  toggle() {
    this.collapsed = !this.element.classList.contains('is-collapsed');
    this.element.classList.toggle('is-collapsed', this.collapsed);
    this.syncControls();
  }

  syncControls() {
    const collapsed = this.element.classList.contains('is-collapsed');
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-label', collapsed ? 'Expand map tools' : 'Collapse map tools');
      this.buttonTarget.setAttribute('title', collapsed ? 'Expand map tools' : 'Collapse map tools');
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('fa-angles-left', !collapsed);
      this.iconTarget.classList.toggle('fa-angles-right', collapsed);
    }
  }

  get collapsed() {
    return window.localStorage.getItem(this.storageKeyValue) === 'true';
  }

  set collapsed(value) {
    window.localStorage.setItem(this.storageKeyValue, value ? 'true' : 'false');
  }
}
